import { createApp } from 'vue'
import CalculateurSunethic from './Calculateur.vue'
import 'leaflet/dist/leaflet.css';
import VueApexCharts from "vue3-apexcharts";
createApp(CalculateurSunethic).use(VueApexCharts).mount('#app_calculateur');
